import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { WhiteboardDraft } from 'utils/whiteboard/drafts/types';
import { selectActiveWhiteboard } from 'features/content-library/contentLibrarySlice';

type WhiteboardDraftsState = {
  available: boolean;
  draft: WhiteboardDraft | null;
  attached: boolean;
  restoring: boolean;
};

export const initialState: WhiteboardDraftsState = {
  available: false,
  draft: null,
  attached: false,
  restoring: false,
};

export const whiteboardDraftsSlice = createSlice({
  name: 'whiteboardDrafts',
  initialState,
  reducers: {
    draftsAvailabilityResolved(state, action: PayloadAction<boolean>) {
      state.available = action.payload;
    },
    draftLoaded(state, action: PayloadAction<WhiteboardDraft | null>) {
      state.draft = action.payload;
    },
    draftUpdated(state, action: PayloadAction<WhiteboardDraft>) {
      state.draft = action.payload;
    },
    draftAttached(state, action: PayloadAction<boolean>) {
      state.attached = action.payload;
    },
    draftRestoreStarted(state) {
      state.restoring = true;
    },
    draftRestoreFinished(state) {
      state.restoring = false;
    },
  },
});

export const {
  draftsAvailabilityResolved,
  draftLoaded,
  draftUpdated,
  draftAttached,
  draftRestoreStarted,
  draftRestoreFinished,
} = whiteboardDraftsSlice.actions;

export const selectDraftsAvailable = (state: RootState) => state.whiteboardDrafts.available;

export const selectIsRestoringWhiteboard = (state: RootState) => state.whiteboardDrafts.restoring;

export const selectWhiteboardDraft = (state: RootState) => state.whiteboardDrafts.draft;

export const selectWhiteboardIsRestorable = (state: RootState) => state.whiteboardDrafts.attached;

export const selectRestoreTarget = (state: RootState) => {
  const draft = selectWhiteboardDraft(state);

  if (!draft || !selectDraftsAvailable(state)) {
    return null;
  }

  return selectActiveWhiteboard(state, draft.whiteboardId) ? null : draft;
};

export default whiteboardDraftsSlice.reducer;
